//will replace the old modal.

import { Box, Button, Card, Modal, styled } from '@mui/material'
import { FC, ReactNode } from 'react'
import CardHeader from '../Card/CardHeader'
import { theme } from '@/theme/theme'

type FullModalParams = {
  open: boolean
  onClose?: () => void
  title: string
  onConfirm?: (params?: any) => void
  buttonLabels?: { confirm?: string; cancel?: string }
  actions?: ReactNode[] | ReactNode
  children: ReactNode[] | ReactNode
}

const FullModal: FC<FullModalParams> = ({ open, onClose, onConfirm, title, buttonLabels, actions, children }) => (
  <Modal open={open} onClose={onClose} sx={{ margin: 5 }}>
    <StyledModalContent>
      <CardHeader title={title} fontSize={'22px'}>
        {actions}
      </CardHeader>
      <Box paddingTop={4}>
        {children}
        <Box display="flex" justifyContent="flex-end" paddingTop={2} gap={1}>
          {buttonLabels?.cancel && (
            <Button variant="outlined" fullWidth sx={{ width: '145px' }} onClick={onClose}>
              {buttonLabels?.cancel}
            </Button>
          )}
          {buttonLabels?.confirm && (
            <Button variant="contained" fullWidth sx={{ width: '145px' }} onClick={onConfirm}>
              {buttonLabels?.confirm}
            </Button>
          )}
        </Box>
      </Box>
    </StyledModalContent>
  </Modal>
)

const StyledModalContent = styled(Card)(() => ({
  height: 'auto',
  padding: theme.spacing(6),
  maxWidth: (window.innerHeight * 16) / 9 - (200 * 16) / 9,
  minWidth: 400,
  position: 'absolute',
  width: '100%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  top: '50%',
}))

export default FullModal
